import { useConnectionItems } from "hooks/useConnectionItems";
import { programConnection } from "./Program/ProgramPicker/ProgramPicker";
import { DocumentNode } from "graphql";

export function useProgram<T extends { id: string }>(programId: string | undefined, fragments: DocumentNode[]) {
  const [programsIx] = useConnectionItems<T>(programConnection, fragments, programId ? [programId] : []);

  return programId ? programsIx[programId] : null;
}
